import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  Header,
  HorizontalStack,
  Icon,
  Image,
  KCol,
  KContentMenu,
  KContentMenuItem,
  KContentMenuPanel,
  KDatePicker,
  KGallery,
  KPanel,
  KRow,
  Label,
  TextInput,
  VerticalStack,
} from "../../components/web-components";
import { KSelectBox } from "../../kuika";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { Screen_Group_Employee_Grid_Card_with_Search_ScreenBase } from "./screen_group_employee_grid_card_with_search-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class Screen_Group_Employee_Grid_Card_with_Search_Screen extends Screen_Group_Employee_Grid_Card_with_Search_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            initialValues={{
              screen_group_employee_grid_card_with_search_925653_value:
                "data:image/png;base64,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",
              screen_group_employee_grid_card_with_search_448749_value:
                "data:image/jpeg;base64,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",
              screen_group_employee_grid_card_with_search_260468_value:
                undefined,
              screen_group_employee_grid_card_with_search_61004_value:
                undefined,
              screen_group_employee_grid_card_with_search_825866_value: "",
            }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <>
              <div
                key="-1"
                id="screen_group_employee_grid_card_with_search_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(244, 244, 244, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    display: "block",
                  } as any
                }
              >
                <Header
                  key="-2"
                  id="screen_group_employee_grid_card_with_search_header"
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      backgroundColor: "rgba(255, 255, 255, 1)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "left",
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KRow
                    key="656461"
                    id="656461"
                    align="top"
                    justify="start"
                    horizontalGutter={0}
                    verticalGutter={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KCol
                      key="53689"
                      id="53689"
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-left",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <HorizontalStack
                        key="195367"
                        id="195367"
                        direction="horizontal"
                        size={12}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="589623"
                          id="589623"
                          iconName="menu"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "20px",
                              color: "rgba(155, 155, 155, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <Form.Item
                          className="kFormItem"
                          name="screen_group_employee_grid_card_with_search_925653_value"
                        >
                          <Image
                            key="925653"
                            id="925653"
                            placeHolderImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/9sAQwABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEB/8AACwgANgBgAQERAP/EABkAAQADAQEAAAAAAAAAAAAAAAAEBQYHCv/EACoQAAEEAgMBAAADCQAAAAAAAAIAAwQFAQYREhMUByEiJDEzNjd1drS1/9oACAEBAAA/APWAiIiIiIiIiIiIiIiIiIqTZrU6HXNgvGmQkO01Ja2rbDhZAHzroD8wGTMeSAHCawBEOM5HBFnHOccKmbpdyyAZe3Zv2yI+vhrVeDHpxjv4g9JfdBrtz5i6+84IcYN1wsZMsq9c25FeRqnf4064oIdhNODN1IW4EvNSWG5zDcttyCE9qLKy3XWjlRPecqpb4MTMsysgyfUq6X99fAnefl9sOLL8u3fz+lgHvPv1Ht079e3Ue3HPGOeFMRERERY78RP6f71/h2z/APEnKlnWG4VVfI2+xkw40SL3lS9Od+BtqPTYHH6BvCHDh7QP8XqUrNG88WKdoBzlu7Wcfk1dY1d3kzU5Ott7TWXLNbbS7CU/jD9jg5BRbKnex8unzdkl4ZneMbsNrPFlu5dZvMx4jvVdc/l6h/s1X/osK5RERERV1xVx7uotKWWTgxbeunVcomSEXhjz4zsR4miITEXMNullssgY4LjORLGM4WAk6hu8+XVS7LctcsBpwA40OTo9h8Dtk3x53UuNG3mOMiyaxgvm7fsMNwykQ4LEkQfCxs9e3O6rp1RZbLqxV9nFfgzcRdHsG5XzSWyadzGcm7xZQ25AgWSYckwJjLbuANyM8I5AtvEjNQosaGx28IkdmMz2z2LyYbFpvsXGOxdAxznGMc5/PjH7lIREREREREREREREREREX//Z"
                            zoomOnClick={false}
                            imageFit="fit"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                height: "24px",
                                maxHeight: "24px",
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                display: "inline",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></Image>
                        </Form.Item>
                      </HorizontalStack>
                    </KCol>
                    <KCol
                      key="114211"
                      id="114211"
                      xs={12}
                      sm={12}
                      md={12}
                      lg={12}
                      xl={12}
                      xxl={12}
                      order={0}
                      pull={0}
                      push={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "center",
                          textAlign: "-webkit-right",
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <HorizontalStack
                        key="640802"
                        id="640802"
                        direction="horizontal"
                        size={12}
                        overflowX="auto"
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 0,
                            paddingRight: 0,
                            paddingBottom: 0,
                            paddingLeft: 0,
                            alignItems: "center",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <Icon
                          key="488010"
                          id="488010"
                          iconName="notifications_none"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              alignItems: "center",
                              textAlign: "-webkit-left",
                              display: "inline",
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "20px",
                              color: "rgba(155, 155, 155, 1)",
                              letterSpacing: "1px",
                            } as any
                          }
                        ></Icon>
                        <KContentMenu
                          key="769586"
                          id="769586"
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KContentMenuPanel
                            key="846304"
                            id="846304"
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="screen_group_employee_grid_card_with_search_448749_value"
                            >
                              <Image
                                key="448749"
                                id="448749"
                                placeHolderImage="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/9sAQwABAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEB/8AACwgANgBgAQERAP/EABkAAQADAQEAAAAAAAAAAAAAAAAEBQYHCv/EACoQAAEEAgMBAAADCQAAAAAAAAIAAwQFAQYREhMUByEiJDEzNjd1drS1/9oACAEBAAA/APWAiIiIiIiIiIiIiIiIiIqTZrU6HXNgvGmQkO01Ja2rbDhZAHzroD8wGTMeSAHCawBEOM5HBFnHOccKmbpdyyAZe3Zv2yI+vhrVeDHpxjv4g9JfdBrtz5i6+84IcYN1wsZMsq9c25FeRqnf4064oIdhNODN1IW4EvNSWG5zDcttyCE9qLKy3XWjlRPecqpb4MTMsysgyfUq6X99fAnefl9sOLL8u3fz+lgHvPv1Ht079e3Ue3HPGOeFMRERERY78RP6f71/h2z/APEnKlnWG4VVfI2+xkw40SL3lS9Od+BtqPTYHH6BvCHDh7QP8XqUrNG88WKdoBzlu7Wcfk1dY1d3kzU5Ott7TWXLNbbS7CU/jD9jg5BRbKnex8unzdkl4ZneMbsNrPFlu5dZvMx4jvVdc/l6h/s1X/osK5RERERV1xVx7uotKWWTgxbeunVcomSEXhjz4zsR4miITEXMNullssgY4LjORLGM4WAk6hu8+XVS7LctcsBpwA40OTo9h8Dtk3x53UuNG3mOMiyaxgvm7fsMNwykQ4LEkQfCxs9e3O6rp1RZbLqxV9nFfgzcRdHsG5XzSWyadzGcm7xZQ25AgWSYckwJjLbuANyM8I5AtvEjNQosaGx28IkdmMz2z2LyYbFpvsXGOxdAxznGMc5/PjH7lIREREREREREREREREREX//Z"
                                zoomOnClick={false}
                                imageFit="fill"
                                style={
                                  {
                                    borderTopLeftRadius: 200,
                                    borderTopRightRadius: 200,
                                    borderBottomRightRadius: 200,
                                    borderBottomLeftRadius: 200,
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    maxWidth: "32px",
                                    maxHeight: "32px",
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              ></Image>
                            </Form.Item>
                          </KContentMenuPanel>
                          <KContentMenuItem
                            key="750222"
                            id="750222"
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              750222,
                              "label",
                              this.defaultML
                            )}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundColor: "rgba(255, 255, 255, 1)",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                                backgroundPosition: "left",
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></KContentMenuItem>
                          <KContentMenuItem
                            key="532153"
                            id="532153"
                            label={ReactSystemFunctions.translate(
                              this.ml,
                              532153,
                              "label",
                              this.defaultML
                            )}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundColor: "rgba(255, 255, 255, 1)",
                                backgroundRepeat: "no-repeat",
                                backgroundSize: "contain",
                                backgroundPosition: "left",
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "center",
                                textAlign: "-webkit-left",
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          ></KContentMenuItem>
                        </KContentMenu>
                      </HorizontalStack>
                    </KCol>
                  </KRow>
                </Header>
                <KRow
                  key="450858"
                  id="450858"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KCol
                    key="217218"
                    id="217218"
                    xs={24}
                    sm={12}
                    md={12}
                    lg={12}
                    xl={12}
                    xxl={12}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <Form.Item
                      className="kFormItem"
                      name="screen_group_employee_grid_card_with_search_260468_value"
                    >
                      <TextInput
                        key="260468"
                        id="260468"
                        kuikaRef={
                          this
                            .screen_group_employee_grid_card_with_search_260468_value_kuikaTextInputRef
                        }
                        placeholder={ReactSystemFunctions.translate(
                          this.ml,
                          260468,
                          "placeholder",
                          this.defaultML
                        )}
                        allowClear={false}
                        bordered={true}
                        disabled={false}
                        type="text"
                        iconColor="rgba(0, 0, 0, 1)"
                        formatter="None"
                        isCharOnly={false}
                        autoComplete={true}
                        style={
                          {
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4,
                            borderBottomRightRadius: 4,
                            borderBottomLeftRadius: 4,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "rgba(218, 218, 218, 1)",
                            borderStyle: "solid",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "block",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></TextInput>
                    </Form.Item>
                  </KCol>
                  <KCol
                    key="416877"
                    id="416877"
                    xs={24}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    xxl={6}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <Form.Item
                      className="kFormItem"
                      name="screen_group_employee_grid_card_with_search_61004_value"
                    >
                      <KSelectBox
                        key="61004"
                        id="61004"
                        kuikaRef={
                          this
                            .screen_group_employee_grid_card_with_search_61004_value_kuikaSelectBoxRef
                        }
                        options={this.state.dataSource_61004}
                        placeholder={ReactSystemFunctions.translate(
                          this.ml,
                          61004,
                          "placeholder",
                          this.defaultML
                        )}
                        allowClear={false}
                        autoClearSearchValue={true}
                        showSearch={false}
                        widthType="fill"
                        containsNullItem={false}
                        sortBy="none"
                        style={
                          {
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4,
                            borderBottomRightRadius: 4,
                            borderBottomLeftRadius: 4,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "rgba(218, 218, 218, 1)",
                            borderStyle: "solid",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "block",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></KSelectBox>
                    </Form.Item>
                  </KCol>
                  <KCol
                    key="97319"
                    id="97319"
                    xs={24}
                    sm={6}
                    md={6}
                    lg={6}
                    xl={6}
                    xxl={6}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <Form.Item
                      className="kFormItem"
                      name="screen_group_employee_grid_card_with_search_825866_value"
                    >
                      <KDatePicker
                        key="825866"
                        id="825866"
                        kuikaRef={
                          this
                            .screen_group_employee_grid_card_with_search_825866_value_kuikaDateRef
                        }
                        placeholder={ReactSystemFunctions.translate(
                          this.ml,
                          825866,
                          "placeholder",
                          this.defaultML
                        )}
                        allowClear={true}
                        format="DD/MM/YYYY"
                        style={
                          {
                            borderTopLeftRadius: 4,
                            borderTopRightRadius: 4,
                            borderBottomRightRadius: 4,
                            borderBottomLeftRadius: 4,
                            borderTopWidth: 1,
                            borderRightWidth: 1,
                            borderBottomWidth: 1,
                            borderLeftWidth: 1,
                            borderColor: "rgba(218, 218, 218, 1)",
                            borderStyle: "solid",
                            backgroundColor: "rgba(255, 255, 255, 1)",
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "contain",
                            backgroundPosition: "left",
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "center",
                            textAlign: "-webkit-left",
                            display: "block",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      ></KDatePicker>
                    </Form.Item>
                  </KCol>
                </KRow>
                <KRow
                  key="503183"
                  id="503183"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 0,
                      paddingRight: 0,
                      paddingBottom: 0,
                      paddingLeft: 0,
                      fontFamily: "Poppins",
                      fontWeight: 500,
                      fontSize: "14px",
                      color: "rgba(68, 68, 68, 1)",
                    } as any
                  }
                >
                  <KCol
                    key="51731"
                    id="51731"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(68, 68, 68, 1)",
                      } as any
                    }
                  >
                    <KGallery
                      key="440196"
                      id="440196"
                      kuikaRef={
                        this
                          .screen_group_employee_grid_card_with_search_440196_value_kuikaGalleryViewRef
                      }
                      nodatafoundmessage={ReactSystemFunctions.translate(
                        this.ml,
                        440196,
                        "nodatafoundmessage",
                        this.defaultML
                      )}
                      dataSource={this.state.dataSource_440196}
                      loading={false}
                      phoneColumnsCount={1}
                      tabletColumnsCount={3}
                      desktopColumnsCount={4}
                      hoverFontColor="black"
                      hoverBgColor="white"
                      horizontalGutter={0}
                      verticalGutter={0}
                      showNoDataFoundImage={false}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 0,
                          paddingRight: 0,
                          paddingBottom: 0,
                          paddingLeft: 0,
                          fontFamily: "Poppins",
                          fontWeight: 500,
                          fontSize: "14px",
                          color: "rgba(68, 68, 68, 1)",
                        } as any
                      }
                    >
                      <KRow
                        key="722532"
                        id="722532"
                        align="top"
                        justify="start"
                        horizontalGutter={0}
                        verticalGutter={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                            fontFamily: "Poppins",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "rgba(68, 68, 68, 1)",
                          } as any
                        }
                      >
                        <KCol
                          key="195769"
                          id="195769"
                          xs={24}
                          sm={24}
                          md={24}
                          lg={24}
                          xl={24}
                          xxl={24}
                          order={0}
                          pull={0}
                          push={0}
                          style={
                            {
                              borderTopLeftRadius: 12,
                              borderTopRightRadius: 12,
                              borderBottomRightRadius: 12,
                              borderBottomLeftRadius: 12,
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              backgroundColor: "rgba(255, 255, 255, 1)",
                              backgroundRepeat: "no-repeat",
                              backgroundSize: "contain",
                              backgroundPosition: "left",
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                              fontFamily: "Poppins",
                              fontWeight: 500,
                              fontSize: "14px",
                              color: "rgba(68, 68, 68, 1)",
                            } as any
                          }
                        >
                          <KPanel
                            key="996309"
                            id="996309"
                            scrolling="hidden"
                            scrollRadius={false}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 0,
                                paddingRight: 0,
                                paddingBottom: 0,
                                paddingLeft: 0,
                                fontFamily: "Poppins",
                                fontWeight: 500,
                                fontSize: "14px",
                                color: "rgba(68, 68, 68, 1)",
                              } as any
                            }
                          >
                            <KRow
                              key="451229"
                              id="451229"
                              align="top"
                              justify="start"
                              horizontalGutter={0}
                              verticalGutter={0}
                              style={
                                {
                                  borderStyle: "solid",
                                  borderTopWidth: 0,
                                  borderRightWidth: 0,
                                  borderBottomWidth: 0,
                                  borderLeftWidth: 0,
                                  paddingTop: 0,
                                  paddingRight: 0,
                                  paddingBottom: 0,
                                  paddingLeft: 0,
                                  alignItems: "flex-start",
                                  textAlign: "-webkit-left",
                                  fontFamily: "Poppins",
                                  fontWeight: 500,
                                  fontSize: "14px",
                                  color: "rgba(68, 68, 68, 1)",
                                } as any
                              }
                            >
                              <KCol
                                key="242142"
                                id="242142"
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                                order={0}
                                pull={0}
                                push={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 8,
                                    paddingRight: 8,
                                    paddingBottom: 8,
                                    paddingLeft: 8,
                                    alignItems: "flex-start",
                                    textAlign: "-webkit-left",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KPanel
                                  key="884753"
                                  id="884753"
                                  scrolling="hidden"
                                  scrollRadius={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KRow
                                    key="271833"
                                    id="271833"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="818060"
                                      id="818060"
                                      xs={16}
                                      sm={16}
                                      md={16}
                                      lg={16}
                                      xl={16}
                                      xxl={16}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="430314"
                                        id="430314"
                                        direction="vertical"
                                        size={2}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Label
                                          key="543588"
                                          id="543588"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            543588,
                                            "value",
                                            this.defaultML
                                          )}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "18px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></Label>
                                        <Label
                                          key="182006"
                                          id="182006"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            182006,
                                            "value",
                                            this.defaultML
                                          )}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "12px",
                                              color: "rgba(155, 155, 155, 1)",
                                              lineHeight: "20px",
                                            } as any
                                          }
                                        ></Label>
                                        <Label
                                          key="763910"
                                          id="763910"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            763910,
                                            "value",
                                            this.defaultML
                                          )}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 400,
                                              fontSize: "12px",
                                              color: "rgba(155, 155, 155, 1)",
                                              lineHeight: "20px",
                                            } as any
                                          }
                                        ></Label>
                                      </VerticalStack>
                                    </KCol>
                                    <KCol
                                      key="589889"
                                      id="589889"
                                      xs={8}
                                      sm={8}
                                      md={8}
                                      lg={8}
                                      xl={8}
                                      xxl={8}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KPanel
                                        key="293080"
                                        id="293080"
                                        scrolling="hidden"
                                        scrollRadius={false}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            alignItems: "center",
                                            textAlign: "-webkit-right",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Icon
                                          key="883950"
                                          id="883950"
                                          iconName="remove_red_eye"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "20px",
                                              color: "rgba(155, 155, 155, 1)",
                                              letterSpacing: "1px",
                                            } as any
                                          }
                                        ></Icon>
                                      </KPanel>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="43352"
                                    id="43352"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="668286"
                                      id="668286"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-left",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <HorizontalStack
                                        key="822417"
                                        id="822417"
                                        direction="horizontal"
                                        size={12}
                                        overflowX="auto"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <Icon
                                          key="965223"
                                          id="965223"
                                          iconName="date_range"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "20px",
                                              color: "rgba(74, 144, 226, 1)",
                                              letterSpacing: "1px",
                                            } as any
                                          }
                                        ></Icon>
                                        <Label
                                          key="121903"
                                          id="121903"
                                          value={ReactSystemFunctions.translate(
                                            this.ml,
                                            121903,
                                            "value",
                                            this.defaultML
                                          )}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              alignItems: "center",
                                              textAlign: "-webkit-left",
                                              display: "inline",
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        ></Label>
                                      </HorizontalStack>
                                    </KCol>
                                  </KRow>
                                  <KRow
                                    key="585780"
                                    id="585780"
                                    align="top"
                                    justify="start"
                                    horizontalGutter={0}
                                    verticalGutter={0}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        alignItems: "flex-start",
                                        textAlign: "-webkit-left",
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KCol
                                      key="57564"
                                      id="57564"
                                      xs={24}
                                      sm={24}
                                      md={24}
                                      lg={24}
                                      xl={24}
                                      xxl={24}
                                      order={0}
                                      pull={0}
                                      push={0}
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 8,
                                          paddingRight: 8,
                                          paddingBottom: 8,
                                          paddingLeft: 8,
                                          alignItems: "flex-start",
                                          textAlign: "-webkit-right",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <VerticalStack
                                        key="668700"
                                        id="668700"
                                        direction="vertical"
                                        size={4}
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 0,
                                            paddingRight: 0,
                                            paddingBottom: 0,
                                            paddingLeft: 0,
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <HorizontalStack
                                          key="425155"
                                          id="425155"
                                          direction="horizontal"
                                          size={12}
                                          overflowX="auto"
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                              paddingTop: 0,
                                              paddingRight: 0,
                                              paddingBottom: 0,
                                              paddingLeft: 0,
                                              fontFamily: "Poppins",
                                              fontWeight: 500,
                                              fontSize: "14px",
                                              color: "rgba(68, 68, 68, 1)",
                                            } as any
                                          }
                                        >
                                          <Label
                                            key="326653"
                                            id="326653"
                                            value={ReactSystemFunctions.translate(
                                              this.ml,
                                              326653,
                                              "value",
                                              this.defaultML
                                            )}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                color: "rgba(68, 68, 68, 1)",
                                              } as any
                                            }
                                          ></Label>
                                          <Icon
                                            key="247465"
                                            id="247465"
                                            iconName="widgets"
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                                paddingTop: 0,
                                                paddingRight: 0,
                                                paddingBottom: 0,
                                                paddingLeft: 0,
                                                alignItems: "center",
                                                textAlign: "-webkit-left",
                                                display: "inline",
                                                fontFamily: "Poppins",
                                                fontWeight: 500,
                                                fontSize: "20px",
                                                color: "rgba(126, 211, 33, 1)",
                                                letterSpacing: "1px",
                                              } as any
                                            }
                                          ></Icon>
                                        </HorizontalStack>
                                      </VerticalStack>
                                    </KCol>
                                  </KRow>
                                </KPanel>
                              </KCol>
                            </KRow>
                          </KPanel>
                        </KCol>
                      </KRow>
                    </KGallery>
                  </KCol>
                </KRow>
              </div>
            </>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(
            mapStateToProps,
            mapDispatchToProps
          )(Screen_Group_Employee_Grid_Card_with_Search_Screen)
        )
      )
    )
  )
);
export { tmp as Screen_Group_Employee_Grid_Card_with_Search_Screen };
//export default tmp;
//export { tmp as Screen_Group_Employee_Grid_Card_with_Search_Screen };
